import React from 'react';
import FontAwesome from 'react-fontawesome';

class ArrowDown extends React.Component {
  render(){
    return(
      <a>        
        <FontAwesome name='angle-down'/>
      </a>
    );
  }
}
export default ArrowDown;
